import React, { useState, useContext, useEffect } from "react";
import { Box, Typography, Button, Checkbox } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import GeneralContext from "../GeneralContext/GeneralContext";
import InputFilter from "../GeneralComponents/InputFilter";
import axios from "../../api/axios";
import PageBody from "../GeneralComponents/PageBody";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import { CircularProgress } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ListEmpty from "../GeneralComponents/ListEmpty";
import PrefacturaAlert from "../GeneralComponents/PrefacturaAlert";
import TablaDescuentosMarkdown from '../utils/TablaDescuentosMarkdown';
import * as XLSX from "xlsx";
import Grid from "@mui/material/Grid2";

import {PERIODS} from "../../Constants/Constants";

let g_start_date = new Date();
g_start_date.setDate(g_start_date.getDate() - 7);
const columns = [
  {
    id: "checkbox",
    label: "",
    width: "5%",
    minWidth: "50px",
    align: "left",
  },
  { id: "rbd", label: "RBD", width: "12%", minWidth: "100px", align: "left" },
  { id: "id_zona", label: "ID zona", width: "12%", minWidth: "100px" },
  {
    id: "operador",
    label: "Operador",
    width: "12%",
    minWidth: "100px",
    align: "left",
  },
  {
    id: "periodo",
    label: "Periodo",
    width: "12%",
    minWidth: "100px",
    align: "left",
  },
  {
    id: "url_link",
    label: "Detalle",
    width: "12%",
    minWidth: "100px",
    align: "center",
  },
];
export default function AlarmList() {
  const [rows, setRows] = useState([]);
  const { includeRol, pageTitle, setPageTitle } = useContext(GeneralContext);
  const [filters, setFilters] = useState({});
  const [filterKey, setFilterKey] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [filteredColumns, setFilteredColumns] = useState([]);
  const [selected, setSelected] = useState([]);
  const navigate = useNavigate();

  const fetchData = async (query) => {
    setLoadingTable(true);
    axios
      .getPrefacturasRBD(query)
      .then((response) => {
        const filtered = response.data.filter(
      (row) => row.link_rbd_detalle !== null && row.link_rbd_detalle !== ""
    );

    const modifiedData = filtered.map((row, index) => ({
      ...row,
      rbd: row.rbd || "",     
      id_zona: row.zona,               
      periodo: row.periodo?.slice(0, 7),    
      url_link: row.link_rbd_detalle,
      id: index,                            
    }));
        setRows(modifiedData);
        setTableData(modifiedData);
      })
      .catch((error) => {})
      .finally(() => {
        setLoadingTable(false);
      });

    const columnOrder = ["rbd", "id_zona", "periodo", "url_link"];

    setFilteredColumns(
      columnOrder
        .map((id) => columns.find((column) => column.id === id))
        .filter(Boolean)
    );
  };

  const downloadXLS = () => {
    const selectedRows = tableData.filter((row) =>
      selected.includes(row.index)
    );

    if (selectedRows.length === 0) {
      alert("No hay filas seleccionadas para descargar.");
      return;
    }

    const filteredData = selectedRows.map((row) => ({
      rbd: row.rbd,
      Zona: row.Zona,
      operador: row.operador,
      Nombre: row.Nombre,
      Convocatoria: row.concurso,
      Fecha_de_Baja: row.Fecha_de_Baja,
      Fecha_de_Alta: row.Fecha_de_Alta,
      estado: row.estado,
    }));

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Tabla");
    XLSX.writeFile(workbook, "tabla.xlsx");
  };    

  const refreshData = (name: String, value: any) => {
    if(value){
      setPage(0);
      setSelected([]);
      setFilterKey((k) => k + 1);
      fetchData(value);
    }
    
  };

  useEffect(() => {
    fetchData(PERIODS[0]);
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const downloadDocs = () => {
    alert(selected);
  };

  const filterRecords = (name: String, value: any) => {
    let filterObj = { ...filters };
    filterObj[name] = value;
    setFilters(filterObj);
    if (value == null) {
      delete filterObj[name];
    }
    if (Object.keys(filterObj).length !== 0) {
      setTableData([
        ...rows.filter((item) =>
          Object.entries(filterObj).every(([key, value]) => item[key] === value)
        ),
      ]);
    } else {
      setTableData(rows);
    }
    setPage(0);
    setSelected([]);
  };


  const downloadReports = (url) => {
    setLoading(true);
    window.open(url, '_blank');
    setLoading(false);
  };

  const handleSelectAll = () => {
    const currentPageIndexes = tableData
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      .map((n) => n.index);
    const allIndexes = rows.map((n) => n.index);

    const isNoneSelected = selected.length === 0;
    const isPageSelected =
      currentPageIndexes.every((index) => selected.includes(index)) &&
      selected.length === currentPageIndexes.length;
    const isAllSelected = selected.length === allIndexes.length;

    if (isNoneSelected) {
      setSelected(currentPageIndexes);
    } else if (isPageSelected) {
      setSelected(allIndexes);
    } else if (isAllSelected) {
      setSelected([]);
    } else {
      setSelected([]);
    }
  };

  const handleCheckboxClick = (index) => {
    const selectedIndex = selected.indexOf(index);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, index);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const isSelected = (index) => selected.indexOf(index) !== -1;

  useEffect(() => {
    setPageTitle("Listado de reportes");
  }, [pageTitle, setPageTitle]);

  return (
    <>
      <PageBody>
        <PrefacturaAlert/>

      <PageBgBlock pad="0">
              <Box
                sx={{
                  paddingLeft: "9rem",
                  paddingRight: "9rem",
                  paddingTop: "2rem",
                  paddingBottom: "2rem",
                }}
              >
                <Typography
                  variant="h1"
                  color="inherit"
                  noWrap
                  sx={{ flexGrow: 1, textAlign: "center", fontWeight: 700 }}
                >
                  DETALLE DE PREFACTURA POR RBD
                </Typography>

                <Box
                  justifyContent="center"
                  sx={{ maxWidth: "100%", margin: "0 auto", display: "flex" }}
                >
                  <Typography
                    variant="body"
                    align="center"
                    sx={{ margin: "1rem 2rem 3rem" }}
                  >
                    Si se necesita saber el detalle de la prefactura por un RBD
                    único, con toda la información de descuentos y saldos puede
                    encontrarla buscando el RBD en específico y descargando el
                    archivo adjunto a disposición
                  </Typography>
                </Box>
                <Grid
                  container
                  spacing={1}
                  sx={{ marginBottom: "2rem", marginTop: "-1rem" }}
                >
        <Grid size={3}>
          <InputFilter
            opt={PERIODS}
            data={rows}
            value={PERIODS[0]}
            item={"periodo"}
            name={"Periodo"}
            callback={refreshData}
          />
        </Grid>
                  <Grid size={3}>
                    <InputFilter
                      data={rows}
                      item={"rbd"}
                      name={"RBD"}
                      key={filterKey}   
                      callback={filterRecords}
                    />
                  </Grid>
                </Grid>


        {loadingTable ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
              width: "100%",
              backgroundColor: "white",
            }}
          >
            <CircularProgress />
            <Typography variant="h6" sx={{ marginTop: 2 }}>
              Cargando...
            </Typography>
          </Box>
        ) : (
          <>
            

                <TableContainer>
                  <Table size="small" aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {filteredColumns.map((column, index) => (
                          <TableCell
                            key={"CL" + index}
                            align={column.align}
                            style={{ minWidth: column.minWidth }}
                          >
                            {column.id === "checkbox" ? (
                              <Box display="flex" alignItems="center">
                                <Checkbox
                                  color="primary"
                                  indeterminate={
                                    selected.length > 0 &&
                                    selected.length < tableData.length
                                  }
                                  checked={
                                    tableData.length > 0 &&
                                    selected.length === tableData.length
                                  }
                                  onChange={handleSelectAll}
                                  inputProps={{ "aria-label": "select all" }}
                                />

                                {column.label}
                              </Box>
                            ) : (
                              column.label
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tableData
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          const isItemSelected = isSelected(row.index);

                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={"TR" + index}
                              aria-checked={isItemSelected}
                              selected={isItemSelected}
                              style={{ paddingBottom: 0, paddingTop: 0 }}
                            >
                              {filteredColumns.map((column, index) => {
                                const value = row[column.id];
                                return (
                                  <TableCell
                                    key={"TC" + index}
                                    align={column.align}
                                  >
                                    {column.id.startsWith("url") ? (
                                      <Button
                                        disabled={!value}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          downloadReports(value);
                                        }}
                                        key={`${column.id}.button.${index}`}
                                        variant="text"
                                      >
                                        <Typography
                                          key={`${column.id}.typ.${index}`}
                                          sx={{
                                            color: !value ? "#grey" : "#111" ,
                                            textTransform: "none",
                                            textDecoration: "underline",
                                          }}
                                        >
                                          Descargar
                                        </Typography>
                                      </Button>
                                    ) : column.id === "checkbox" ? (
                                      <Checkbox
                                        color="primary"
                                        checked={isItemSelected}
                                        onClick={() =>
                                          handleCheckboxClick(row.index)
                                        }
                                        inputProps={{
                                          "aria-labelledby": row.index,
                                        }}
                                      />
                                    ) : column.id === "estado" ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          flexWrap: "no-wrap",
                                        }}
                                      >
                                        <FiberManualRecordIcon
                                          sx={{
                                            fontSize: "0.75rem",
                                            color:
                                              value === "Alta"
                                                ? "#41AE43"
                                                : "#FB3B3B",
                                            marginRight: "0.5rem",
                                          }}
                                        />

                                        {value}
                                      </div>
                                    ) : (
                                      value
                                    )}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                  {tableData.length === 0 ? <ListEmpty></ListEmpty> : null}
                

                <TablePagination
                  sx={{ paddingBottom: "2rem" }}
                  rowsPerPageOptions={[5, 10, 25, 100]}
                  component="div"
                  count={tableData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
                </TableContainer>

                       <TablaDescuentosMarkdown 
                            sx={{ paddingBottom: "2rem" }}
                        />
          </>
        )}

              </Box>
            </PageBgBlock>
      </PageBody>
    </>
  );
}

